import axios from "axios";

import { getCurrentLanguageFromUrl } from "./urlLanguageUtils";
import { queryClient } from "../Store/store";

const instance = axios.create({
  baseURL: "https://api.lamtakam.com",
  withCredentials: true,
  timeout: 120000,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const urlLanguage = getCurrentLanguageFromUrl();
    const localStorageLanguage = localStorage.getItem("i18nextLng");
    const currentLanguage = urlLanguage || localStorageLanguage || "fa";

    if (config.headers) {
      config.headers.lang = currentLanguage;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const urlLanguage = getCurrentLanguageFromUrl();
    const localStorageLanguage = localStorage.getItem("i18nextLng");
    const currentLanguage = urlLanguage || localStorageLanguage || "fa";

    if (status === 401) {
      //Clear React Query cache (in-memory)
      queryClient.clear();

      if (localStorage.getItem("reloadedOnce") !== "true") {
        setTimeout(() => {
          localStorage.setItem("reloadedOnce", "true");
          window.location.reload();
        }, 1000);
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
